import { TrashIcon } from '@radix-ui/react-icons'
import { AlertDialog, Button, Flex, IconButton } from '@radix-ui/themes'

export const DeleteUserAlert = ({
  userName,
  onDelete,
}: {
  userName: string
  onDelete: () => void
}) => {
  return (
    <AlertDialog.Root>
      <AlertDialog.Trigger>
        <IconButton variant="ghost" style={{ width: '100%', cursor: 'pointer' }}>
          <TrashIcon />
        </IconButton>
      </AlertDialog.Trigger>
      <AlertDialog.Content maxWidth="450px">
        <AlertDialog.Title>Delete {userName}</AlertDialog.Title>
        <AlertDialog.Description size="2">
          Are you sure? This cannot be revered, deleted users will need to be recreated
        </AlertDialog.Description>

        <Flex gap="3" mt="4" justify="end">
          <AlertDialog.Cancel>
            <Button variant="soft" color="gray" style={{ cursor: 'pointer' }}>
              Cancel
            </Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button variant="solid" color="red" style={{ cursor: 'pointer' }} onClick={onDelete}>
              Delete
            </Button>
          </AlertDialog.Action>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  )
}
